import React, {useContext, useState} from "react";
import ApiService  from "../../../services/api.service";
import {ThemeContext} from "../../../styles/ThemeContext";
const Login = ({ setUserCredentials, setValidationDetails, userName, setUsername, passWord, setPassword, modalVisible, setModalVisible, setPage, showLoader }) => {
    const [step, setStep] = useState("login");
    const [inputClass, setinputClass] = useState('disable')
    const [togglePassword, setPasswordVisible] = useState(false);
    const { theme } = useContext(ThemeContext);
    const handleChangeInput = (e) => {
        e.length > 3 ? setinputClass('active') : setinputClass("disable")
        setError('')
    }
    const handlePasswordInput = (e) => {
        setError('')
    }
    const[inputerr, setError] = useState('')
    const toggleView = () => {
         setPasswordVisible(prevCheck => !prevCheck)
    }

    const encode = (str) => {
        window.Buffer = window.Buffer || require("buffer").Buffer;
        return Buffer.from(String(str)).toString('base64');
    }
   
    const handleLogin = (e) => {
        e.preventDefault();
        showLoader(true)
        if (step === 'login') {
            ApiService.post("/auth/validate_agrodealer", { username: userName }).subscribe((res) => {
                setError('');
                showLoader(false)
                if (res.status == 200) {
                    showLoader(false)
                    setValidationDetails(res.data)
                    
                    if (res.data.firstLogin === false) {
                        setStep('password');
                    } else if (res.data.firstLogin) {
                        setUserCredentials({ "PhoneNumber": res.data.phoneNumber })
                        const payload = {
                            username: userName,
                            password: encode(passWord)
                        }
                        ApiService.post("/auth/send_otp", payload).subscribe((res) => {
                            if (res.status === 200) {
                                setModalVisible(true)
                            }

                        })
                        setModalVisible(true)
                    } else {
                        setPage("password");
                    }

                }
                else if (res.response !== undefined && res.response.status === 400) {
                    showLoader(false)
                    setError(res.response.data && res.response.data.error ? res.response.data.error : "An error occured")
                } else if (res.response !== undefined && res.response.status === 500) {
                    setError(res.response.data.message ? res.response.data.message : "Internal Server Error")
                } else if (res.code === "ERR_NETWORK") {
                    setError("No internet connection");
                } else {
                    setError("An error occured");
                }
            })
        } else {
            const payload = {
                username: userName,
                password: encode(passWord)
            }
            const subscription = ApiService.post("/auth/login", payload).subscribe((res) => {
                showLoader(false)
                if (res.status === 200) {
                    const time = new Date();
                    let logtime = { "logtime": time.getTime() }
                    const userdata = Object.assign(res.data, logtime)
                    setUserCredentials(userdata)
                    const payload = {
                        username: userName,
                    }
                    const subscription = ApiService.post("/auth/send_otp", payload).subscribe((res) => {
                        if (res.status === 200) {
                            setModalVisible(true)
                        }

                    })

                }
                else if (res.response !== undefined && res.response.status === 400) {
                    setError("Invalid username or password")
                } else {
                    setError("An error occurred")
                }

            })
        }
    }

    return (
        <>
            {step === "password" && <div className="back-holder" onClick={() => {
                setStep("login")
            }}><span className="back-text">Back</span></div>}

            <h2 className="login-card-welcome" style={{}}>WELCOME TO</h2>
            <h1 className="login-card-sub-title"
                style={{marginTop: '1rem', marginBottom: '0.5rem', color:theme.colors.primary}}> {theme.app_title1} </h1>
            <h1 className="login-card-sub-title"
                style={{marginTop: '-1rem', marginBottom: '2rem', color:theme.colors.primary}}> {theme.app_title2} </h1>

            <span>Enter your {step === "login" ? "username" : "password"} to continue</span>
            <div className="form input-row">
                {step === "login" &&
                    <input type="text" className={`input ${inputerr ? 'input-error' : ''}`} onChange={(e) => {
                        handleChangeInput(e.target.value);
                        setUsername(e.target.value.replace(/\s/g, ''));
                    }} placeholder="Enter username"/>}
                {step === "password" && <input type={togglePassword ? "text" : "password"} autoComplete="off"
                                               className="input login-password" onChange={(e) => {
                    handlePasswordInput(e);
                    setPassword(e.target.value);
                }} placeholder="*********"/>}
                {step === "password" &&
                    <svg id="icon-remove_red_eye" className="eye toggle-eye" onClick={toggleView} viewBox="0 0 24 24">
                        {togglePassword ? <path
                                d="M12 9q1.219 0 2.109 0.891t0.891 2.109-0.891 2.109-2.109 0.891-2.109-0.891-0.891-2.109 0.891-2.109 2.109-0.891zM12 17.016q2.063 0 3.539-1.477t1.477-3.539-1.477-3.539-3.539-1.477-3.539 1.477-1.477 3.539 1.477 3.539 3.539 1.477zM12 4.5q3.703 0 6.703 2.063t4.313 5.438q-1.313 3.375-4.313 5.438t-6.703 2.063-6.703-2.063-4.313-5.438q1.313-3.375 4.313-5.438t6.703-2.063z"></path> :
                            <path
                                d="M11.859 9h0.141q1.219 0 2.109 0.891t0.891 2.109v0.188zM7.547 9.797q-0.563 1.125-0.563 2.203 0 2.063 1.477 3.539t3.539 1.477q1.078 0 2.203-0.563l-1.547-1.547q-0.375 0.094-0.656 0.094-1.219 0-2.109-0.891t-0.891-2.109q0-0.281 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266q-0.234-0.234-1.477-1.453t-1.898-1.875q-2.016 0.844-4.359 0.844-3.703 0-6.703-2.063t-4.313-5.438q0.516-1.219 1.617-2.695t2.133-2.273q-0.563-0.563-1.57-1.594t-1.148-1.172zM12 6.984q-0.938 0-1.828 0.375l-2.156-2.156q1.828-0.703 3.984-0.703 3.703 0 6.68 2.063t4.289 5.438q-1.125 2.766-3.422 4.734l-2.906-2.906q0.375-0.891 0.375-1.828 0-2.063-1.477-3.539t-3.539-1.477z"></path>} </svg>}
                <><span className="error-label">{inputerr ? inputerr : ''}</span></>

            </div>
            <button className={`btn-submit login-btn ${inputClass}`} onClick={(e) => {
                handleLogin(e);
            }} type='submit'> {step === "login" ? "CONTINUE" : "SIGN IN"}</button>
            <div className="login-card-footer"><span>Having trouble logging in? <a className="link get-help"
                                                                                   style={{cursor: 'pointer'}}
                                                                                   onClick={(e) => {
                                                                                       e.preventDefault();
                                                                                       setPage('self')
                                                                                   }}>Get Help</a></span></div>
        </>

    );
}

export default Login;
